export default "__VITE_ASSET__CyDvO9LC__"